import React from "react";
import { Info } from "lucide-react";
import Popover from "./Popover";

/** A small hover-info icon that reveals an explanatory tooltip. */
const InfoIcon: React.FC<{ info: string; className?: string }> = ({
  info,
  className = "",
}) => (
  <Popover
    openOnHover
    trigger={
      <button
        type="button"
        className={`text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 ${className}`}
      >
        <Info size={13} />
      </button>
    }
  >
    <div className="max-w-xs px-3 py-2 text-xs font-normal text-gray-600 dark:text-gray-300">
      {info}
    </div>
  </Popover>
);

/** A field/column label with a hover-info icon next to it, explaining it. */
export const InfoLabel: React.FC<{ label: string; info: string; className?: string }> = ({
  label,
  info,
  className = "",
}) => (
  <div
    className={`flex items-center gap-1 text-sm font-medium text-gray-700 dark:text-gray-300 ${className}`}
  >
    <span>{label}</span>
    <InfoIcon info={info} />
  </div>
);

export default InfoIcon;
